import { useRef } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { checksForCard, FillCard, type FillCheck } from '@/models/fillApplication'
import { FillTabSection } from '../App/Customers/FillApplication/FillTabSection'
import type { LossRunUpload } from './useLossRunUpload'

// The types the chat's loss run step takes.
const LOSS_RUN_FILE_TYPES = '.csv,.pdf,.jpg,.jpeg,.png,.xlsx,.xls'

interface ConfirmLossRunsCardProps {
  checks: FillCheck[]
  upload: LossRunUpload
}

/** The customer picks their loss run reports here; Save sends them for Cai to read. */
export function ConfirmLossRunsCard({ checks, upload }: ConfirmLossRunsCardProps) {
  const fileInputRef = useRef<HTMLInputElement>(null)

  return (
    <FillTabSection
      card={FillCard.LOSS_RUNS}
      title="Loss runs"
      checks={checksForCard(checks, FillCard.LOSS_RUNS)}
      saving={upload.saving}
    >
      <div className="flex flex-col items-center gap-4 py-6">
        <Input
          ref={fileInputRef}
          type="file"
          multiple
          accept={LOSS_RUN_FILE_TYPES}
          className="hidden"
          onChange={(event) => {
            upload.addFiles(Array.from(event.target.files ?? []))
            // Cleared so picking the same file again still fires a change.
            event.target.value = ''
          }}
        />
        <Button type="button" className="text-md" onClick={() => fileInputRef.current?.click()}>
          Upload loss run reports
        </Button>
        {upload.files.length > 0 && (
          <ul className="text-ink-500 flex flex-col items-center gap-1 text-sm">
            {upload.files.map((file, index) => (
              <li key={`${index}-${file.name}`}>{file.name}</li>
            ))}
          </ul>
        )}
      </div>
    </FillTabSection>
  )
}
